import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import Login from '@/views/login/index'
import Account from '@/views/account/index'
import AddAccount from '@/views/account/add'
import EditAccount from '@/views/account/edit'
import WatchAccount from '@/views/account/watch'
import Material from '@/views/material-manage/index'
import MaterialWatch from '@/views/material-manage/watch'
import LogisticsWatch from '@/views/logistics/watch'
import Materialedit from '@/views/material-manage/edit'
import WorkLoad from '@/views/workload/index'
import workloadSee from '@/views/workload/each'
import Keyword from '@/views/keyword/index'
import Keyshen from '@/views/keyword/setingshen'
import Keywu from '@/views/keyword/setingwu'
import Keyte from '@/views/keyword/settingte'
import Logistics from '@/views/logistics/index'
import LogisticsEdit from '@/views/logistics/edit'
import ConcentrateLogistics from '@/views/concentrate-mode-logistics/index'
import ConcentrateMaterial from '@/views/concentrate-mode-material/index'

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/account',
    component: Layout,
    hidden: true,
    meta: {
      title: '系统设置'
    },
    children: [
      {
        path: 'index',
        component: Account,
        name: 'account',
        meta: {
          title: '账号管理',
          activeMenu: '/account'
        }
      },
      {
        path: 'add',
        component: AddAccount,
        name: 'addaccount',
        meta: {
          title: '添加账号',
          activeMenu: '/account'
        }
      },
      {
        path: 'edit/:id',
        component: EditAccount,
        name: 'editaccount',
        meta: {
          title: '编辑账号'
        }
      },
      {
        path: 'watch/:id',
        component: WatchAccount,
        name: 'watchaccount',
        meta: {
          title: '查看账号'
        }
      }
    ]
  },
  {
    path: '/keyword',
    component: Layout,
    children: [
      {
        path: 'index',
        component: Keyword,
        name: 'keyword',
        meta: {
          title: '材料关键字管理',
          icon: 'center'
        }
      },
      {
        path: 'shen',
        component: Keyshen,
        name: 'keyshen',
        meta: {
          title: '审核关键字管理',
          icon: 'center',
          activeMenu: '/keyword/index'
        },
        hidden: true
      },
      {
        path: 'wu',
        component: Keywu,
        name: 'keywu',
        meta: {
          title: '物流关键字管理',
          icon: 'center',
          activeMenu: '/keyword/index'
        },
        hidden: true
      },
      {
        path: 'te',
        component: Keyte,
        name: 'keyte',
        meta: {
          title: '特殊材料关键字',
          icon: 'center',
          activeMenu: '/keyword/index'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/material',
    component: Layout,
    children: [
      {
        path: 'index',
        component: Material,
        name: 'material',
        meta: {
          title: '患者审核材料管理',
          icon: 'center'
        }
      },
      {
        path: 'watch/:id',
        component: MaterialWatch,
        name: 'materialwatch',
        meta: {
          title: '患者材料详情',
          noCache: true,
          activeMenu: '/material/index'
        },
        hidden: true
      },
      {
        path: 'edit/:id/:projectId',
        component: Materialedit,
        name: 'materialedit',
        meta: {
          title: '患者材料编辑',
          noCache: true,
          activeMenu: '/material/index'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/logistics',
    component: Layout,
    children: [
      {
        path: 'index',
        component: Logistics,
        name: 'Logistics',
        meta: {
          title: '患者物流材料管理',
          icon: 'center'
        }
      },
      {
        path: 'watch/:id',
        component: LogisticsWatch,
        name: 'logisticswatch',
        meta: {
          title: '患者物流材料详情',
          noCache: true,
          activeMenu: '/logistics/index'
        },
        hidden: true
      },
      {
        path: 'edit/:id/:projectId',
        component: LogisticsEdit,
        name: 'logisticsedit',
        meta: {
          title: '患者物流材料编辑',
          noCache: true,
          activeMenu: '/logistics/index'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/workload',
    component: Layout,
    children: [
      {
        path: 'page',
        component: WorkLoad,
        name: 'workload',
        meta: {
          title: '工作量统计',
          icon: 'monitor'
        }
      },
      {
        path: 'detail/:accountId/:projectId',
        component: workloadSee,
        name: 'seeworkload',
        hidden: true,
        meta: {
          title: '工作量查看',
          activeMenu: '/workload/page'
        }
      }
    ]
  },
  {
    path: '/concentrate-mode-material',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index/:id/:projectId',
        component: ConcentrateMaterial,
        name: 'concentrateMaterial',
        meta: {
          title: '专注编辑',
          icon: 'monitor'
        }
      }
    ]
  },
  {
    path: '/concentrate-mode-logistics',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index/:id/:projectId',
        component: ConcentrateLogistics,
        name: 'concentrateLogistics',
        meta: {
          title: '专注编辑',
          icon: 'monitor'
        }
      }
    ]
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  routes: constantRoutes
})
